import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { BiSearch } from '@react-icons/all-files/bi/BiSearch';
import { searchRepository } from '../../../repository/search.repository';
import './home.feed.search.css';
import { CircularProgress } from '@mui/material';
import { feedViewModel } from '../../views/feed/feed.view.model';

const HomeFeedSearch = (props) => {
  const [searchInput, setSearchInput] = useState('');
  const [searchResultCreations, setSearchResultCreations] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  // const getSearchResult = () => {
  //   setLoading(true);
  //   searchRepository
  //     .getSearchResult(searchInput)
  //     .then((res) => {
  //       setSearchResultCreations(res.data.creations || []);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // };

  const getSearchResult = () => {
    setLoading(true);
    let query = {
      limit: 20,
      has_more: true,
      trending: false,
      starting_after: 0,
      title: searchInput,
    };
    let tempArr = [];
    feedViewModel
      .getFeed(query, tempArr)
      .then((res) => {
        setSearchResultCreations(res.feedList || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (searchInput) {
  //     getSearchResult();
  //   } else {
  //     setSearchResultCreations([]);
  //   }
  // }, [searchInput]);

  const onInputChange = (e) => {
    setSearchInput(e.target.value);
    props?.handleInputChange(e.target.value);
    if (!e.target.value) {
      setIsDropdownVisible(false);
    } else {
      setIsDropdownVisible(true); // Show dropdown on input change
    }
  };

  const onCreationClick = (title) => {
    props?.handleInputChange(title);
    setSearchInput(title);
    setIsDropdownVisible(false); // Hide dropdown after selection
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleBlur = () => {
    setTimeout(() => setIsDropdownVisible(false), 350); // Delay dropdown hide to allow onClick to register
  };

  const handleFocus = () => {
    if (searchInput) {
      setIsDropdownVisible(true); // Show dropdown when search input is focused and has text
    }
  };

  const getSearchWord = (creation) => {
    const lowerCaseSearchInput = searchInput.toLowerCase();

    if (
      creation?.title &&
      creation.title.toLowerCase().includes(lowerCaseSearchInput)
    ) {
      return creation.title;
    }

    if (
      creation?.challenge?.title &&
      creation.challenge.title.toLowerCase().includes(lowerCaseSearchInput)
    ) {
      return creation.challenge.title;
    }

    return null; // Return null if no match is found
  };

  return (
    <div className="accordian-body home-feed-search-box-wrapper">
      <Form className="search-form hide-on-toggle" onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Control
            type="text"
            value={searchInput}
            onChange={onInputChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder="Search creations..."
          />
          <span className="search_ic">
            <BiSearch />
          </span>

          {/* {isDropdownVisible &&
            (loading ? (
              <div className="search-results" style={{ paddingTop: '10px' }}>
                <div className="result-treehouses">
                  <div className="result-row">
                    <div className="result-itm treehouses-itm">
                      <CircularProgress />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="search-results">
                {searchResultCreations.length > 0 ? (
                  <div className="result-challenges">
                    <div className="result-row">
                      {searchResultCreations.map((data, key) => (
                        <div
                          className="creation-item"
                          key={key}
                          onClick={() => onCreationClick(data.title)}
                        >
                          {getSearchWord(data)}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="result-treehouses">
                    <div className="result-row">
                      <div className="result-itm treehouses-itm">
                        No result found
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))} */}
        </Form.Group>
      </Form>
    </div>
  );
};

export default HomeFeedSearch;
